module.exports = __webpack_public_path__ + "static/quality-improvement-002829beed5a7006c0527a8df8afcb14.jpg";